import {Component} from "@angular/core";
import {GO_COMPONENTS} from "../../../enums/e-game-objects";
import {GoBaseComponent} from "../go-base.component";
import {UI_TEXTS} from "../../../enums/e-texts";


@Component({
    selector: "go-pasture",
    templateUrl: "./go-pasture.component.html"
})


export class GoPastureComponent extends GoBaseComponent {
    UI_TEXTS = UI_TEXTS;


    constructor() {
        super(GO_COMPONENTS.PASTURE);
    }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/go/go-pasture/go-pasture.component.ts